/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getConceptDataTypes } from 'app/entities/concept-data-type/concept-data-type.reducer';
import { getEntities as getLabTestCategories } from 'app/entities/lab-test-category/lab-test-category.reducer';
import { getEntities as getCatalogDefinitions } from 'app/entities/catalog-definitions/catalog-definitions.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-item.reducer';

export const LabTestItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const conceptDataTypes = useAppSelector(state => state.conceptDataType.entities);
  const labTestCategories = useAppSelector(state => state.labTestCategory.entities);
  const catalogDefinitions = useAppSelector(state => state.catalogDefinitions.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const labTestItemEntity = useAppSelector(state => state.labTestItem.entity);
  const loading = useAppSelector(state => state.labTestItem.loading);
  const updating = useAppSelector(state => state.labTestItem.updating);
  const updateSuccess = useAppSelector(state => state.labTestItem.updateSuccess);

  const handleClose = () => {
    navigate(`/lab-test-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getConceptDataTypes({}));
    dispatch(getLabTestCategories({}));
    dispatch(getCatalogDefinitions({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.sortOrder !== undefined && typeof values.sortOrder !== 'number') {
      values.sortOrder = Number(values.sortOrder);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...labTestItemEntity,
      ...values,
      dataType: conceptDataTypes.find(it => it.id.toString() === values.dataType?.toString()),
      category: labTestCategories.find(it => it.id.toString() === values.category?.toString()),
      catalog: catalogDefinitions.find(it => it.id.toString() === values.catalog?.toString()),
      testType: clinicalDictionaries.find(it => it.id.toString() === values.testType?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...labTestItemEntity,
          dataType: labTestItemEntity?.dataType?.id,
          category: labTestItemEntity?.category?.id,
          catalog: labTestItemEntity?.catalog?.id,
          testType: labTestItemEntity?.testType?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labTestItem.home.createOrEditLabel" data-cy="LabTestItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labTestItem.home.createOrEditLabel">Create or edit a LabTestItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-item-id"
                  label={translate('tinyMedicRestApp.labTestItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.active')}
                id="lab-test-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.lastupdated')}
                id="lab-test-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.measurement')}
                id="lab-test-item-measurement"
                name="measurement"
                data-cy="measurement"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.methodName')}
                id="lab-test-item-methodName"
                name="methodName"
                data-cy="methodName"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.sortOrder')}
                id="lab-test-item-sortOrder"
                name="sortOrder"
                data-cy="sortOrder"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.testLocalAbbrev')}
                id="lab-test-item-testLocalAbbrev"
                name="testLocalAbbrev"
                data-cy="testLocalAbbrev"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.testName')}
                id="lab-test-item-testName"
                name="testName"
                data-cy="testName"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.timestampentry')}
                id="lab-test-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.microSec')}
                id="lab-test-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.cursor')}
                id="lab-test-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItem.sample')}
                id="lab-test-item-sample"
                name="sample"
                data-cy="sample"
                type="text"
                validate={{
                  maxLength: { value: 64, message: translate('entity.validation.maxlength', { max: 64 }) },
                }}
              />
              <ValidatedField
                id="lab-test-item-dataType"
                name="dataType"
                data-cy="dataType"
                label={translate('tinyMedicRestApp.labTestItem.dataType')}
                type="select"
              >
                <option value="" key="0" />
                {conceptDataTypes
                  ? conceptDataTypes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.labTestItem.category')}
                type="select"
                required
              >
                <option value="" key="0" />
                {labTestCategories
                  ? labTestCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="lab-test-item-catalog"
                name="catalog"
                data-cy="catalog"
                label={translate('tinyMedicRestApp.labTestItem.catalog')}
                type="select"
              >
                <option value="" key="0" />
                {catalogDefinitions
                  ? catalogDefinitions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-item-testType"
                name="testType"
                data-cy="testType"
                label={translate('tinyMedicRestApp.labTestItem.testType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-test-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestItemUpdate;
